import { Chip, makeStyles } from "@material-ui/core";

import React from "react";
import { get } from "lodash";
import { red } from "@material-ui/core/colors";
import { useTranslate } from "react-admin";

const COLORS = {
  completed: "primary",
  incomplete: "secondary",
  not_started: "primary",
};
const useStyles = makeStyles((theme) => ({
  not_started: {
    backgroundColor: red[500],
  },
}));
const ProgressField = ({ ...props }) => {
  const classes = useStyles();
  const translate = useTranslate();

  const progress = get(props, "record.progress");
  return (
    <Chip
      className={get(classes, progress)}
      label={translate(`resources.research-project-evals.progress.${progress}`)}
      color={get(COLORS, progress, "default")}
    />
  );
};
export default ProgressField;
